import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { forYou, notForYou } from "../data/landing";
import { MobileAccordion } from "./MobileAccordion";
import { Reveal, STAGGER } from "./Reveal";
import { SectionHeader } from "./SectionHeader";
const FOR_TITLE = "Tiene sentido si:";
const NOT_TITLE = "Probablemente no es el momento si:";
export function WhoItsFor() {
  return <section aria-labelledby="para-ti" className="section-pad border-b border-line bg-surface" data-id="element-383" data-mp="dnpbnbntlsjo">
      <div className="page-container" data-id="element-384" data-mp="horbnupka8mp">
        <Reveal data-id="element-385" data-mp="hpu3c4upkf3o">
          <SectionHeader number="02" label="Para quién es" titleId="para-ti" title="¿Esto es para ti?" data-id="element-386" data-mp="hpaiaf9rhalf" />
        </Reveal>

        <MobileAccordion className="mt-8" items={[{
        id: "para-ti",
        title: FOR_TITLE,
        content: <ul className="space-y-3" data-id="element-388" data-mp="3q4kj7k1x09rm">
                  {forYou.map(text => <li key={text} className="flex gap-3" data-id="element-389" data-mp="3v2cl96w9xc9j">
                      <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-gold" strokeWidth={2.5} aria-hidden="true" data-id="element-390" data-mp="1zq8chxgmyity" />
                      <span className="text-[16px] leading-snug text-cream" data-id="element-391" data-mp="1vp6dnhqms8si">{text}</span>
                    </li>)}
                </ul>
      }, {
        id: "no-para-ti",
        title: <span className="text-muted" data-id="element-392" data-mp="1lw7nvwjeec7b">{NOT_TITLE}</span>,
        content: <ul className="space-y-3" data-id="element-393" data-mp="1h0iktj866d69">
                  {notForYou.map(text => <li key={text} className="flex gap-3" data-id="element-394" data-mp="1bykuk51cqi3t">
                      <XIcon className="mt-1 h-4 w-4 shrink-0 text-steel" strokeWidth={2.5} aria-hidden="true" data-id="element-395" data-mp="17y0yl4silkj9" />
                      <span className="text-[16px] leading-snug text-muted" data-id="element-396" data-mp="1307pa2vx0aer">{text}</span>
                    </li>)}
                </ul>
      }]} data-id="element-387" data-mp="mmat13hk31iv" />

        <div className="mt-12 hidden gap-6 md:grid md:grid-cols-2" data-id="element-397" data-mp="2xeii0mfmropt">
          <Reveal className="h-full" data-id="element-398" data-mp="3gic7c8h8huec">
            <div className="h-full rounded-[3px] border border-gold/40 bg-ink p-10" data-id="element-399" data-mp="3ghaj12b7jbeo">
              <h3 className="h3-item" data-id="element-400" data-mp="3l92ffth1obcq">{FOR_TITLE}</h3>
              <ul className="mt-6 divide-y divide-line border-t border-line" data-id="element-401" data-mp="3lan8fenpnm8h">
                {forYou.map(text => <li key={text} className="flex gap-4 py-4" data-id="element-402" data-mp="3cg8t5c36kbpd">
                    <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-gold" strokeWidth={2.5} aria-hidden="true" data-id="element-403" data-mp="3cgqqkc1kwvyv" />
                    <span className="text-cream" data-id="element-404" data-mp="3yuk1d63hrd3">{text}</span>
                  </li>)}
              </ul>
            </div>
          </Reveal>
          <Reveal delay={STAGGER} className="h-full" data-id="element-405" data-mp="3q73um3bcnqix">
            <div className="h-full rounded-[3px] border border-line p-10" data-id="element-406" data-mp="3v6zym2k1rhyh">
              <h3 className="h3-item !text-muted" data-id="element-407" data-mp="3v92zxiqngxii">{NOT_TITLE}</h3>
              <ul className="mt-6 divide-y divide-line border-t border-line" data-id="element-408" data-mp="2eryqcuvkljx7">
                {notForYou.map(text => <li key={text} className="flex gap-4 py-4" data-id="element-409" data-mp="2jt4ml2ofvpbh">
                    <XIcon className="mt-1 h-4 w-4 shrink-0 text-steel" strokeWidth={2.5} aria-hidden="true" data-id="element-410" data-mp="2c7iswpmpd467" />
                    <span className="text-muted" data-id="element-411" data-mp="278fon7ejr1za">{text}</span>
                  </li>)}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}